<template lang='pug'>
  div(class="header-section-new")
    div(class="header-content-new")
      .header-text
        .title.page-title(v-text='$t("account.rewardsBoutique.title")')

      .cta-container
        AuthPopupLink(:classes='["btn", "join"]' type='register' :text='registerBtnText')
        .or(v-text='$t("common.or")')
        AuthPopupLink(:classes='["btn", "btn-white", "sign-in"]' type='signIn' :text='signInBtnText')
</template>

<i18n>
{
  "lng_en": {
    "join": "join beauty pass",
    "signIn": "sign in"
  },
  "lng_id": {
    "join": "Daftar Beauty Pass",
    "signIn": "Masuk"
  },
  "lng_th": {
    "join": "สมัคร Beauty Pass",
    "signIn": "ลงชื่อเข้าใช้"
  },
  "lng_zh": {
    "join": "加入Beauty Pass",
    "signIn": "登入"
  },
  "lng_ko": {
    "join": "뷰티 패스 가입하기",
    "signIn": "로그인"
  }
}
</i18n>

<script>
import AuthPopupLink from '@/components/layout/auth-popup-link.vue'

export default {
  name: 'GuestHeader',

  components: {
    AuthPopupLink
  },

  computed: {
    registerBtnText () {
      return this.$t('account.rewardsBoutique.guestHeader.signUp')
    },

    signInBtnText () {
      return this.$t('account.rewardsBoutique.guestHeader.signIn')
    }
  }
}
</script>

<style lang='scss' scoped>
  .header-section {
    background-image: url('../../assets/images/account/beauty_pass/hero_mobile.jpg');
    background-size: cover;
    height: 200px;
    margin-bottom: 60px;
    margin-left: -10px;
    margin-right: -10px;
    padding-top: 55px;
    @include media-breakpoint-up(sm) {
      background-image: url('../../assets/images/account/beauty_pass/hero_web.jpg');
      padding-top: 85px;
      margin-bottom: 80px;
    }
    @include media-breakpoint-up(xl) {
      height: 325px;
      margin-bottom: 0;
      padding-top: 50px;
    }
    @include media-breakpoint-up(xl) {
      padding-top: 120px;
    }
  }

  .header-content {
    width: 100%;
    @include media-breakpoint-up(sm) {
      margin-left: auto;
      margin-right: auto;
      width: 566px;
    }
  }

  .header-section-new {
    background-image: url('../../assets/images/account/beauty_pass/banner-2021.jpeg');
    background-size: cover;
    min-height: 200px;
    margin-bottom: 32px;
    margin-left: -10px;
    margin-right: -10px;
    padding: 55px 0;

    @include media-breakpoint-up(sm) {
      padding-top: 85px;
    }

    @include media-breakpoint-up(xl) {
      height: 325px;
      padding-top: 50px;
    }
  }

  .header-content-new {
    width: 100%;
    margin: auto;
    background-color: white;
    padding: 3em;
    width: fit-content;
    border: 1px solid #e6e6e6;
    box-shadow: 0 2px 8px 1px rgb(64, 60, 67 / 24%);

    @include media-breakpoint-down(sm) {
      padding: 1.5em 0.5em;
    }
  }

  .header-text {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    width: 265px;

    @include media-breakpoint-up(sm) {
      width: 380px;
    }

    @include media-breakpoint-up(lg) {
      width: 450px;
    }

    @include media-breakpoint-up(xl) {
      margin-bottom: 20px;
      width: 100%;
    }

    > .title {
      font-size: 24px;
      margin-bottom: 12px;
      text-transform: uppercase;

      @include media-breakpoint-up(sm) {
        font-size: 34px;
        margin-bottom: 20px;
      }

      @include media-breakpoint-up(xl) {
        font-size: 55px;
        margin-bottom: 30px;
      }
    }
  }

  .cta-container {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin: 5px;
    margin-top: 15px;
    margin-left: auto;

    @include media-breakpoint-up(sm) {
      margin-top: 30px;
    }

    @include media-breakpoint-up(xl) {
      margin-top: 20px;
    }

    > .join {
      flex-grow: 1;
      text-transform: uppercase;

      @include media-breakpoint-down(sm) {
        font-size: 12px;
      }

      @media (max-width: 320px) {
        font-size: 11px;
      }
    }

    > .or {
      margin-left: 6px;
      margin-right: 6px;

      @include media-breakpoint-up(sm) {
        margin-left: 20px;
        margin-right: 20px;
      }

      @media (max-width: 360px) {
        font-size: 12px;
        margin-left: 3px;
        margin-right: 3px;
      }

      @media (max-width: 320px) {
        font-size: 10px;
      }
    }

    > .sign-in {
      flex-grow: 1;
      text-transform: uppercase;

      @include media-breakpoint-down(sm) {
        font-size: 12px;
      }

      @media (max-width: 320px) {
        font-size: 11px;
      }
    }
  }
</style>
